export enum CalculatedPerType {
    Encounter = 1,
    Episode = 2,
}
